import n from "classnames";
import e from "react";
import { s as d } from "../grid.module-BaK_X3T2.mjs";
const m = e.forwardRef(({ children: r, className: a = "", dataTestId: t = null, style: i, ...o }, s) => /* @__PURE__ */ e.createElement(
  "div",
  {
    ref: s,
    className: n(
      d.grid__container,
      "grid-container fuse-responsive-grid__container",
      a
    ),
    "data-testid": t,
    style: i,
    ...o
  },
  r
));
m.displayName = "GridContainer";
export {
  m as GridContainer
};
